import * as React from "react";

import { Link, makeStyles, Typography } from "@material-ui/core";

import { logAmplitudeEvent } from "client/lib/amplitude";

const useStyles = makeStyles(() => ({
  text: {
    fontSize: "0.9rem",
  },
}));

export const CraRegistryIdHelperText: React.FC = () => {
  const classes = useStyles();
  return (
    <Typography className={classes.text} variant="body2">
      You can find your registry ID by searching for it at{" "}
      <Link
        color="primary"
        href="https://beta.canadasbusinessregistries.ca/search"
        rel="noopener"
        target="_blank"
        onClick={() => {
          logAmplitudeEvent(
            "REDESIGN_ADD_YOUR_STORE",
            "clicked_ca_business_register_link"
          );
        }}
      >
        MRAS Business Registry Search
      </Link>
    </Typography>
  );
};
